/**
 * Mapas y helpers de normalización de parámetros del peludo:
 * convierten las claves en inglés que devuelve la API (age_category, body_condition,
 * activity_level) a las etiquetas en español que usan los componentes del editor.
 *
 * Fuente única de verdad — importar desde aquí en ParamsEditor y CardSelector.
 */

export const AGE_MAP: Record<string, string> = {
  puppy: 'cachorro',
  adult: 'adulto',
  senior: 'senior',
};

export const BODY_MAP: Record<string, string> = {
  thin: 'delgado',
  ideal: 'ideal',
  overweight: 'sobrepeso',
};

export const ACTIVITY_MAP: Record<string, string> = {
  low: 'bajo',
  medium: 'medio',
  // 'moderate' es otro alias legacy visto en datos antiguos de pets — sin
  // esta entrada pasaba crudo y /calculate-plan lo rechazaba con 422.
  moderate: 'medio',
  high: 'alto',
};

export const DIET_MAP: Record<string, string> = {
  complete: 'completa',
  mixed: 'mixta',
};

export const normalizeAge = (v: string | null | undefined): string => AGE_MAP[v ?? ''] ?? v ?? 'adulto';

export const normalizeBody = (v: string | null | undefined): string => BODY_MAP[v ?? ''] ?? v ?? 'ideal';

export const normalizeActivity = (v: string | null | undefined): string => ACTIVITY_MAP[v ?? ''] ?? v ?? 'medio';

export const normalizeDiet = (v: string | null | undefined): string => DIET_MAP[v ?? ''] ?? v ?? 'completa';
